// extracted by mini-css-extract-plugin
module.exports = {"wholeHomeBackupPowerSolution":"whole-home-backup-power-solution_wholeHomeBackupPowerSolution__Jwedy"};